export const navigationRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    // {
    //   name: 'alunos/financeiro',
    //   displayName: 'menu.Financeiros',
    //   meta: {
    //     iconClass: 'va-icon glyphicon glyphicon-usd',
    //   },
    // },
    // {
    //   name: 'alunos/notas',
    //   displayName: 'menu.Notas',
    //   meta: {
    //     iconClass: 'va-icon glyphicon glyphicon-list-alt',
    //   },
    // },
    // {
    //   name: 'alunos/perfil',
    //   displayName: 'menu.Perfil',
    //   meta: {
    //     iconClass: 'va-icon glyphicon glyphicon-user',
    //   },
    // },
    // {
    //   name: 'alunos/acessos',
    //   displayName: 'menu.Acessos',
    //   meta: {
    //     iconClass: 'va-icon glyphicon glyphicon-calendar',
    //   },
    // },
  ],
}
